export const TAB_KEYS = {
    OPPORTUNITIES: 'opportunities',
    MY_INVESTMENTS: 'my-investments',
};
